import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/page-metadata";
import ProtectedRoute from "@/components/auth/ProtectedRoute";
import { IndustryBuilderGuard } from "@/components/auth/IndustryBuilderGuard";
import CleaningProposalBuilder from "@/pages/CleaningProposalBuilder";
export const Route = createFileRoute("/cleaning-builder")({ head: ({match}) => pageHead(match.pathname), component: () => (<ProtectedRoute><IndustryBuilderGuard industry="cleaning"><CleaningProposalBuilder /></IndustryBuilderGuard></ProtectedRoute>) });
